<style scoped lang="less">
</style>
<template>
	<div>
		<titles titlename="导入题目" titlecontent="这里可以看到导入题目一些信息" :mbx="paths"></titles>
		
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	
	export default{
		data(){
			return{
				// 标题
				paths: [{
					path: "/homesview/testists/questionbank",
					name: "导入题目"
				}],
			}
		},
		components: {
			titles
		}
		
	}
	
	
</script>

